import React from 'react';
import { ButtonProps } from 'antd/lib/button';
import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import CcNode from '../../../services/models/CcNode';
import ButtonWithForm from '../../../common/General/ButtonWithForm';
import JobActionButton from '../../Jobs/JobActionButton';
import NodeEnableBinaryLoggingForm from './NodeEnableBinaryLoggingForm';

export default NodeEnableBinaryLoggingButton;

export type NodeEnableBinaryLoggingButtonProps = ButtonProps & {
    node: CcNode;
    children?: React.ReactNode;
    onSuccess?: () => void;
};

function NodeEnableBinaryLoggingButton({
    node,
    children,
    onSuccess,
    ...rest
}: NodeEnableBinaryLoggingButtonProps) {
    return (
        <ButtonWithForm
            button={
                <JobActionButton
                    command={CmonJobInstanceCommand.ENABLE_BINARY_LOGGING}
                    clusterId={node.clusterid}
                    extraKey={[node.hostname, node.port]}
                    switchValue={false}
                    {...rest}
                >
                    {children || 'Binary logging'}
                </JobActionButton>
            }
            form={
                <NodeEnableBinaryLoggingForm
                    node={node}
                    onSuccess={onSuccess}
                />
            }
        />
    );
}
